module.exports = __webpack_public_path__ + "img/drop.d9fe865f.png";